import { ApiError } from '@ziggiz/api';

/** Authentication failures keep the API error shape and are never retried. */
export class AuthError extends ApiError {
  constructor(message: string, code = 'sign_in_required') {
    super(message, 401, code);
    this.name = 'AuthError';
  }
}
